//@ts-nocheck
import React from "react";
import Box from "@mui/material/Box";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { SecondaryButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { MinerOperationsTab } from "./MoreOperations/MinerOperationTab.js";
import { GroupOperationsTab } from "./GroupOperations/GroupOperations.js";
import TagOperationsCard, {
  TagOperationsTab,
} from "./TagOperations/TagOperations.js";
import { Tooltip, Chip } from "@mui/material";
import { set } from "lodash";
import useSiteAndGroupTreeContext from "../../context/useSiteAndGroupTreeContext.js";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import {
  BodyLarge,
  H8TitleMedium,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import CreateCaseModal from "../../../caseManagement/Components/CreateCaseModal.js";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";
import { useAuth0 } from "@auth0/auth0-react";

export const MinerTableOperationsContainer = React.memo(
  (props) => {
    const { colors } = useTheme();
    const {
      refetch,
      resetTableSelection,
      downloadCSV,
      setTableKey,
      user,
      setJobTransferDialogOpen,
      transferCount,
      setLeftSidePanelOpen,
      tableData,
    } = props;

    const [createCaseModalOpen, setCreateCaseModalOpen] = React.useState(false);
    const { siteSelectedName, groupSelectedName } =
      useSiteAndGroupTreeContext();
    const { selectedSerials, selectedChassisSerials } = useMinerPageContext();
    const { role } = user ? user : {};

    const isDisabled =
      !siteSelectedName && siteSelectedName === "";

    const hasSite = Boolean(siteSelectedName);
    const hasGroup = Boolean(groupSelectedName);
    const hasSelectedSerials =
      Array.isArray(selectedSerials) &&
      selectedSerials.length > 0;

    let locationLabel = "";
    if (hasSite && hasGroup) {
      locationLabel = "selected group";
    } else if (hasSite) {
      locationLabel = "selected site";
    }

    let minerInventoryLabel = "";
    if (!hasSelectedSerials) {
      minerInventoryLabel = `all miners in ${locationLabel}`;
    } else if (hasSelectedSerials) {
      const plural =
        selectedSerials.length === 1 ? "miner" : "miners";
      minerInventoryLabel = `${selectedSerials.length} selected ${plural} in ${locationLabel}`;
    }

    return (
      <>
        <Box
          className={"table-operations-container"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box
            className={"table-operations-container-left"}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            maxWidth="100%"
          >
            {!isDisabled && minerInventoryLabel && (
              <BodyLarge
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  Actions enabled
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      bottom: 0,
                      height: "2px",
                      backgroundColor: colors.text.primary,
                      display: "block",
                      transition: "width 0.5s ease-out",
                    }}
                    ref={(el) => {
                      if (el) {
                        requestAnimationFrame(() => {
                          el.style.width = "100%";
                        });
                      }
                    }}
                  ></span>
                </span>{" "}
                for {minerInventoryLabel}
              </BodyLarge>
            )}
          </Box>

          <Box
            className={"table-operations-container-right"}
            display={"flex"}
            flexDirection={"row"}
            gap={2}
          >
            <Tooltip
              title={
                "Enabled when miners are transferred to you"
              }
              arrow
            >
              <span>
                <SecondaryButton colors={colors}
                  colors={colors}
                  endIcon={
                    <span className="material-symbols-outlined">
                      switch_access_3
                    </span>
                  }
                  disabled={
                    role !== "superadmin" ||
                    transferCount <= 0
                  }
                  onClick={(event) => {
                    event.stopPropagation();
                    setJobTransferDialogOpen(true);
                  }}
                >
                  Accept/Reject Transfers
                </SecondaryButton>
              </span>
            </Tooltip>
            <Tooltip
              title="Create a support case for the selected miner(s)"
              arrow
            >
              <span>
                <SecondaryButton colors={colors}
                colors={colors}
                  endIcon={
                    <span className="material-symbols-outlined">
                      add_task
                    </span>
                  }
                  disabled={selectedSerials.length === 0}
                  onClick={(event) => {
                    event.stopPropagation();
                    setCreateCaseModalOpen(true);
                  }}
                >
                  Create Case
                </SecondaryButton>
              </span>
            </Tooltip>
            <GroupOperationsTab
              refetch={refetch}
              setTableKey={setTableKey}
              resetTableSelection={resetTableSelection}
              userRole={role}
              setLeftSidePanelOpen={setLeftSidePanelOpen}
            />
            <TagOperationsTab
              refetch={refetch}
              setTableKey={setTableKey}
              userRole={role}
            />
            <MinerOperationsTab
              downloadCSV={downloadCSV}
              refetch={refetch}
              setTableKey={setTableKey}
              role={role}
              setLeftSidePanelOpen={setLeftSidePanelOpen}
            />
          </Box>
        </Box>

        <CreateCaseModal
          open={createCaseModalOpen}
          setOpen={setCreateCaseModalOpen}
          refetch={refetch}
          setTableKey={setTableKey}
          prePopulatedSerialNumbers={selectedChassisSerials.length > 0 ? selectedChassisSerials.filter(serial => serial && serial.trim() !== '').join('\n') : ""}
          prePopulatedSerialNumberType="chassis"
        />
      </>
    );
  }
);
